export const API = "https://anoopam.com/aims/api/"